import { Page } from 'layouts/Page';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { getIsAuth, getMerchantId } from 'redux/reducers/auth/selectors';
import { setHmrcOauthRequest } from 'redux/reducers/settings/reducer';
import { Box, Button, Typography } from '@mui/material';
import { getHmrcOauthUrlError, getHmrcOauthUrlLoader } from 'redux/reducers/settings/selectors';
import {
	INTEGRATIONS_PLATFORMS_IMG_TEXT,
	IntegrationsPlatform,
} from 'redux/reducers/integrations/constants';

export const HmrcPage: FC = () => {
	// console.log(window.location.pathname, window.location.search);
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	const isAuth = useSelector(getIsAuth);
	const merchantIdSelector = useSelector(getMerchantId);
	const hmrcError = useSelector(getHmrcOauthUrlError);
	const hmrcLoader = useSelector(getHmrcOauthUrlLoader);

	const dispatch = useDispatch();

	useEffect(() => {
		// console.log('navigateParams', navigateParams);
		if (navigateParams.code && navigateParams.state) {
			dispatch(
				setHmrcOauthRequest({
					code: String(navigateParams.code),
					state: String(navigateParams.state),
				}),
			);
		}
	}, [dispatch, navigateParams]);

	window.onbeforeunload = () => {
		window.close();
	};

	return (
		// <Page title="HMRC – EAS Dashboard">
		// </Page>
		<main className="main">
			<div className="main-content">
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100%',
						p: '100px 20px 20px 20px',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: '6px',
						}}
					>
						<img
							style={{ height: '50px', objectFit: 'contain', textAlign: 'left' }}
							src="/img/platformLogo/hmrc.png"
							alt="HMRC"
						/>
						<Typography
							style={{
								fontSize: '1.6rem',
								fontWeight: 550,
								color: '#000',
							}}
						>
							{INTEGRATIONS_PLATFORMS_IMG_TEXT[IntegrationsPlatform.HMRC]}
						</Typography>
					</Box>
					<Typography
						style={{
							fontSize: '1.2rem',
							fontWeight: 550,
							padding: '20px 0 40px 0',
							color: hmrcError === null ? 'success.main' : 'error.main',
						}}
					>
						{hmrcLoader && 'Please wait...'}
						{hmrcError !== null && (hmrcError ?? 'Error occurred while integrating with HMRC')}
						{hmrcError === null &&
							!hmrcLoader &&
							'EAS solution successfully connected to the HM Revenue and Customs services'}
					</Typography>

					<Button
						type="button"
						variant="contained"
						color="primary"
						onClick={() => {
							window.close();
						}}
					>
						Close
					</Button>
				</Box>
			</div>
		</main>
	);
};
